export const updateTaskKanbanService = (fetch) => async (task, file) => {
  try {
    let body = task;
    let contentType = "application/json";

    if (task.status === "completada" && file) {
      const formData = new FormData();
      Object.entries(task).forEach(([key, value]) => {
        if (value != null) formData.append(key, value);
      });
      formData.append("supportDocument", file);
      body = formData;
      contentType = "multipart/form-data";
    }

    const response = await fetch({
      url: `/api/v1/plan-trabajo-capacitacion/actualizar-tarea/${task.id}`,
      method: "put",
      body,
      contentType
    })

    return response
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message)
  }
}
